import { Operator } from "./Operator";
// import { FilterValue } from "./FilterValue"
import { Expression } from "./Expression";
import { makeObservable, observable, runInAction } from "mobx";

enum SelectType {
  SINGLE= 'single',
  MULTIPLE= 'multiple'
}

export class FilterItem extends Expression {
  // 操作符
  operator: Operator;
  // name 查询字段
  name: string;
  // 值
  value: any = "";
  // 实体字段
  field: string;
  returnArr: Array<any>
  selectType: string;
  filterStore: any
  constructor(
    name: string,
    value: any,
    operator: Operator = Operator.EQUAL,
    activated = true,
    visible = true,
    meta: any,
    field: string,
    filterStore: any
  ) {
    super(activated, visible, meta);
    if (!name) {
      throw new Error("查询字段名称为空,检查storeField字段是否配置");//@notranslate
    }
    this.filterStore = filterStore
    this.field = field
    this.name = name;
    this.operator = operator;
    this.value = value;
    this.activated = activated;
    this.returnArr = []
    this.selectType = ''
    makeObservable(this, {
      value: observable,
      name: observable,
      operator: observable,
      field: observable
    });
    if (meta?.refReturnArr) {
      const refReturnArr = JSON.parse(meta.refReturnArr);
      // 兼容一个值带入多个字段字段间用;分割的场景
      this.returnArr = this.adaptRefReturnArr(refReturnArr)
      this.selectType = meta?.selectType
    }
  }

    /**
   * 兼容参照refReturnArr一个值带入多个字段字段间用;分割的场景
   */
  adaptRefReturnArr = (refReturnArr: any) => {
    const returnArr: any[] = []
    for (const referStoreAlias in refReturnArr) {
      // 要带入的字段
      const returnField = refReturnArr[referStoreAlias]
      // 要将一个值带入到多个字段, 字段之间用会;分割
      returnField.split(';').forEach((item: any) => {
        const returnFieldArr = item.split(',')
        returnArr.push({
          storeKey: returnFieldArr[0],
          realKey: returnFieldArr[1],
          key: referStoreAlias
        })
      })
    }
    return returnArr
  }

  /**
   * 所有涉及到this调用的地方都改成了箭头函数，组件层调用出错，模型层兼容
   */

  /**
   *  设置 查询操作符
   * @param operator 字符串或者Operator对象
   */
  setOperator = (operator: Operator | string) => {
    if (operator instanceof Operator) {
      this.operator = operator;
    } else {
      this.operator = new Operator(operator);
    }
  }

  /**
   * 设置值
   * @param value
   */
  setValue = (value: any): void => {
    this.value = value;
    if (this.selectType === SelectType.SINGLE) {
      runInAction(() => {
        for (const returnInfo of this.returnArr) {
          const { realKey, key } = returnInfo
          if(realKey === this.name) continue
          if (this.filterStore.getFilterItemByName(realKey)) {
            this.filterStore.getFilterItemByName(realKey).setValue(value?.[key])
          }
        }
      });
    }
  }

  /**
   * 获取value
   * @returns value
   */
  getValue = () => {
    return this.value;
  }

  /**
   * 设置name
   * @param name
   */
  setName = (name: string) => {
    this.name = name;
  }

  /**
   * 获取name
   * @returns name
   */
  getName = (): string => {
    return this.name;
  }

  /**
   * 查询条件值处理
   * @returns 查询条件值处理
   */
  getQueryValue = () => {
    // debugger
    // 一个 logic 里面两个 filterItem
    //   {
    //     "op": "or",
    //     "items": [
    //         {
    //             "op": "like",
    //             "name": "code",
    //             "v1": "60"
    //         },
    //         {
    //             "op": "like",
    //             "name": "title",
    //             "v1": "60"
    //         }
    //     ]
    // }
    let mulFieldLike = this.meta?.mulFieldLike;
    if (mulFieldLike && mulFieldLike.length) {
      mulFieldLike = Array.isArray(mulFieldLike)
        ? mulFieldLike
        : mulFieldLike.split(",");
      if (this.value) {
        const items: any = [];
        mulFieldLike.forEach((name: string) => {
          items.push({ op: this.operator.operator, name, v1: this.value });
        });
        return { op: "or", items };
      }
    }

    if (this.meta?.compareLogic === 'multlike') {
      const values = this.value?.split(/\s+/)
      if (values?.length > 0) {
        const items: any = [];
        values.forEach((value: string) => {
          items.push({ op: 'like', name: this.field ? this.field : this.name, v1: value });
        });
        return { op: "or", items };
      }
    }

    if (this.value && !Array.isArray(this.value) && this.meta?.controlType === 'FilterDateRangePicker') {
      // 移动传过来的值与pc不一致
      const getDataStr = (dateStr: string | number | Date) => {
        const dateObj = new Date(dateStr);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        const modifiedDateStr = `${year}-${month}-${day}`;
        return modifiedDateStr
      }
      const v1 = getDataStr(this.value?.sDate) + ' ' + '00:00:00'
      const v2 = getDataStr(this.value?.eDate) + ' ' + '00:00:00'
      return { op: this.meta?.compareLogic || 'between', name: this.field ? this.field : this.name, v1, v2 }
    }
    //  // 如果有一对多关系，创建一个Logic，嵌套在条件里面，用or 关联
    //  if () {
    //   // eslint-disable-next-line no-const-assign
    //   mulFieldLike = Array.isArray(mulFieldLike) ? mulFieldLike : mulFieldLike.split(',')
    //   const l = new Logic('or', 'default', item.metaItem.alias)
    //   const items = []
    //   mulFieldLike.forEach(name => {
    //     items.push(new FilterItem(name, item.itemStore.value, new Operator('like')))
    //   })
    //   l.setExpressionList(items)

    // this.operator?.operator !== Operator.IN  如果是  in 条件，
    let v1, v2;
    // 如果 count 大于2 并且不是in 条件，处理成2个+字段
    // 如果是 in 条件，直接处理 为 在 v1 上 一个值
    if (
      this.operator.getCount() >= 2 &&
      this.operator?.operator !== Operator.IN.operator
    ) {
      // 容错处理
      if (this.value && Array.isArray(this.value)) {
        v1 = this.value[0];
        v2 = this.value[1];
      }
    } else {
      // 如果是参照
      if (
        this.meta?.controlType === "ReferInputPc" ||
        this.meta?.controlType === "ReferInput" ||
        this.meta?.controlType === "FilterReferInputPc" ||
        this.meta?.controlType === "FilterReferInput"
      ) {
        // 找到查询区的主键，取真实值
        try {
          const refReturnArr = JSON.parse(this.meta.refReturnArr || "{}");
          let primaryKey = "";
          Object.keys(refReturnArr).forEach((key) => {
            const arr = refReturnArr[key].split(",");
            if (arr.pop() === this.name) {
              primaryKey = key;
            }
          });
          // 婷艳说：如果是单选参照，在查询区中，传多个值。canMultiple =true 并且 vlues 数组，有值
          const vals: any[] = [];
          if (
            this.meta.canMultiple &&
            Array.isArray(this.value) &&
            this.value.length
          ) {
            this.value.forEach((item: any) => {
              vals.push(item[primaryKey]);
            });
            v1 = vals;
            // FIXME: 下面这些逻辑都是不应该的，兼容历史错误协议的代码，请若干时间后修复
            if (!['in', 'nin'].includes(this.operator.operator)) {
              if (this.operator.operator === 'neq') {
                this.operator.operator = 'nin';
              } else if (this.operator.operator === 'eq') {
                this.operator.operator = 'in';
              }
            }
          } else {
            v1 = this.value?.[primaryKey];
          }
        } catch (e) {
          console.log(`查询条件${this.name}异常`);
          v1 = undefined;
        }
      } else {
        if (['enumerate', 'select', 'filterenumerate', 'filterselect'].includes(this.meta?.controlType?.toLocaleLowerCase()) && (this.meta?.multiple || this.meta?.canMultiple)) {
          v1 = this.value?.split(',');
        } else {
          v1 = this.value;
        }
      }
    }
    return Object.fromEntries(
      Object.entries({
        op: this.operator.operator,
        // value: this.value,
        name: this.field ? this.field : this.name,
        v1,
        v2
      }).filter(([, v]) => v != null)
    );
  }
}
